import {
  ApiResponse,
  QuestionDto,
  QuizCategoryDto,
  QuizDto,
  SubmitQuiz,
} from "@/types";
import api from "./api";

export async function getQuizList(
  params: Record<string, string>
): Promise<ApiResponse<QuizCategoryDto[]>> {
  try {
    return api.get("/quizz/categories", { params }).then((res) => res.data);
  } catch (error: any) {
    return {
      data: [],
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 12,
      },
    };
  }
}

export async function getQuizCategoryList(
  id: number,
  params: Record<string, string>
): Promise<
  ApiResponse<{
    data: QuizDto[];
    category: {
      id: number;
      title: string;
    };
  }>
> {
  try {
    return api.get(`/quizz/category/${id}`, { params }).then((res) => res.data);
  } catch (error: any) {
    return {
      data: {
        data: [],
        category: {
          id: 0,
          title: "",
        },
      },
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 12,
      },
    };
  }
}

export async function getDoneQuizList(
  params: Record<string, string>
): Promise<ApiResponse<QuizCategoryDto[]>> {
  try {
    return api.get("/quizz/completed", { params }).then((res) => res.data);
  } catch (error: any) {
    return {
      data: [],
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 12,
      },
    };
  }
}

export async function getDoneQuizCategoryList(
  id: number,
  params: Record<string, string>
): Promise<
  ApiResponse<{
    data: QuizDto[];
    category: {
      id: number;
      title: string;
    };
  }>
> {
  try {
    return api
      .get(`/quizz/category/${id}/completed`, { params })
      .then((res) => res.data);
  } catch (error: any) {
    return {
      data: {
        data: [],
        category: {
          id: 0,
          title: "",
        },
      },
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 12,
      },
    };
  }
}

export async function getQuizById(id: number) {
  try {
    return api
      .get<
        ApiResponse<{
          data: QuestionDto[];
          quizz: QuizDto;
        }>
      >(`/quizz/${id}/question?isPagination=0`)
      .then((res) => res.data);
  } catch (error: any) {
    return {
      data: null,
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
    };
  }
}

export async function getQuizResultById(id: number) {
  try {
    return api
      .get<
        ApiResponse<{
          data: QuestionDto[];
          quizz: QuizDto;
        }>
      >(`/quizz/${id}/result?isPagination=0`)
      .then((res) => res.data);
  } catch (error: any) {
    return {
      data: null,
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
    };
  }
}

export async function getQuizRelatedById(id: number) {
  try {
    return api
      .get<ApiResponse<QuizDto[]>>(`/quizz/${id}/related`)
      .then((res) => res.data);
  } catch (error: any) {
    return {
      data: null,
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
    };
  }
}

export async function submitQuiz(data: SubmitQuiz) {
  return api
    .post<ApiResponse<{ user_quiz_id: number }>>("/quizz/submit", data)
    .then((res) => res.data)
    .catch((error: any) => ({
      data: null,
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
    }));
}
